import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, Typography, Grid, CircularProgress, Alert, Divider } from '@mui/material';
import backgroundImg from "../../assets/ImgFundo/fundo-abstratoC.jpg";

const ContagemVisualizacoes = () => {
    const [artigos, setArtigos] = useState([]);
    const [podcasts, setPodcasts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchDados = async () => {
            try {
                console.log("Iniciando as requisições para artigos e podcasts...");

                const responseArtigos = await axios.get(`${apiUrl}/artigos`);
                console.log("Artigos recebidos:", responseArtigos.data);
                setArtigos(responseArtigos.data);

                const responsePodcasts = await axios.get(`${apiUrl}/podcasts`);
                console.log("Podcasts recebidos:", responsePodcasts.data);
                setPodcasts(responsePodcasts.data);

                setLoading(false);
            } catch (error) {
                console.error('Erro ao carregar os dados:', error);
                setErro('Erro ao carregar os dados');
                setLoading(false);
            }
        };

        fetchDados();
    }, []);

    if (loading) return <CircularProgress />;
    if (erro) return <Alert severity="error">{erro}</Alert>;

    return (
        <div
            style={{
                padding: '20px',
                backgroundImage: `url(${backgroundImg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '100vh',
                color: 'white', // Para garantir que o texto tenha boa visibilidade
            }}
        >


            <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
            <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />

            <Typography
                variant="h2"
                align="center"
                gutterBottom
                style={{
                    fontFamily: "'Lato', serif",
                    color: "black",
                    borderBottom: "4px solidrgb(8, 8, 7)",
                    paddingBottom: "10px",
                    textTransform: "uppercase",
                    borderBottom: "4px solid #d4af37",
                    animation: "glow 2s infinite alternate",
                    marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
            >
                Contagem de Visualizações
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Typography
                        variant="h2"
                        align="center"
                        gutterBottom
                        style={{
                            fontFamily: "'Lato', serif",
                            color: "black",
                            borderBottom: "4px solidrgb(8, 8, 7)",
                            paddingBottom: "10px",
                            textTransform: "uppercase",
                            animation: "glow 2s infinite alternate",
                            marginTop: "7%"  // Aqui é onde você define o espaço superior
                        }}
                    >
                        Matérias
                    </Typography>
                    <Divider style={{ marginBottom: '20px', backgroundColor: '#fff' }} /> {/* Linha de separação */}
                    {artigos.map((artigo) => (
                        <Card key={artigo.id} style={{ marginBottom: '16px', backgroundColor: 'rgba(127, 136, 108, 0.6)' }}>
                            <CardContent>
                                <Typography
                                    variant="body2"
                                    align="center"
                                    gutterBottom
                                    style={{
                                        fontFamily: "'Lato', serif",
                                        color: "black",
                                        borderBottom: "4px solidrgb(8, 8, 7)",
                                        paddingBottom: "10px",
                                        textTransform: "uppercase",
                                        animation: "glow 2s infinite alternate",
                                        marginTop: "7%"  // Aqui é onde você define o espaço superior
                                    }}
                                >{artigo.titulo}</Typography>
                                  <Typography 
                                        variant="body2" 
                                        sx={{ color: 'primary.main', fontWeight: 'bold' }}
                                    >
                                        Visualizações: {artigo.visualizacoesArtigo}
                                    
                                    
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography
                        variant="h2"
                        align="center"
                        gutterBottom
                        style={{
                            fontFamily: "'Lato', serif",
                            color: "black",
                            borderBottom: "4px solidrgb(8, 8, 7)",
                            paddingBottom: "10px",
                            textTransform: "uppercase",
                            animation: "glow 2s infinite alternate",
                            marginTop: "7%"  // Aqui é onde você define o espaço superior
                        }}
                    >
                        Podcasts
                    </Typography>
                    <Divider style={{ marginBottom: '20px', backgroundColor: '#fff' }} /> {/* Linha de separação */}
                    {podcasts.map((podcast) => (
                        <Card key={podcast.id} style={{ marginBottom: '16px', backgroundColor: 'rgba(159, 132, 132, 0.6)' }}>
                            <CardContent>
                                <Typography
                                    variant="body2"
                                    align="center"
                                    gutterBottom
                                    style={{
                                        fontFamily: "'Lato', serif",
                                        color: "black",
                                        borderBottom: "4px solidrgb(8, 8, 7)",
                                        paddingBottom: "10px",
                                        textTransform: "uppercase",
                                        animation: "glow 2s infinite alternate",
                                        marginTop: "7%"  // Aqui é onde você define o espaço superior
                                    }}
                                >{podcast.titulo}</Typography>
                               <Typography
                                    variant="body2"
                                    sx={{ color: 'secondary.main', fontWeight: 'bold' }}
                                >Visualizações:  {podcast.visualizacoesPodcast}</Typography>
                                  
                            </CardContent>
                        </Card>
                    ))}
                </Grid>
            </Grid>
        </div>
    );
};

export default ContagemVisualizacoes;
